import React, { useState } from "react";
import background from "../Assets/background.jpeg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from "js-cookie";
import CryptoJS from 'crypto-js';
import baseURL from "../config";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const LoginForm = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  

  const togglePassword = () => {
    setPasswordVisible((prev) => !prev);
  };

  const navigate = useNavigate();

  const handleLogIn = async (e) => {
    e.preventDefault(); 
    var fcmToken = "";
    try {
      const response = await axios.post(
        baseURL+"/api/Login/GetToken",
        {
          email,
          password,
          fcmToken

        }
      );

      if (response.status === 200) {
        const data = response.data;

        if (data.length > 50) {
     
       const secretKey = '19092002'; 
       const encryptedToken = CryptoJS.AES.encrypt(data, secretKey).toString();

      
       Cookies.set("token", encryptedToken, { expires: 1 });

       // Reload the page and navigate to home
       window.location.reload(true);
       navigate('/home');
        } else {
          toast.error("Rishikoi të dhënat!"); // Invalid credentials
        }
      } else {
        toast.error("Unexpected server response.");
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      if (error.response) {
        console.error("Server error:", error.response.data);
        toast.error(error.response.data.message || "Server error occurred.");
      } else {
        console.error("Network or other error:", error.message);
        toast.error("Network error. Please try again.");
      }
    }
  };

  return (
    <div className="Main-div">
      <ToastContainer />
      <section>
        <img src={background} className="background-image" alt="Background" />
        <div className="login">
          <div className="col-1">
            <h2>Sign in</h2>
            <span>Login with your registered account</span>

            <form id="form" className="flex flex-col" onSubmit={handleLogIn}>
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <div className="password-field">
                <input
                  type={passwordVisible ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button type="button" onClick={togglePassword} aria-label="Toggle password visibility">
                  {passwordVisible ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                </button>
              </div>

              <button type="submit" className="btn">
                Login
              </button>
              <div className="other">
                <Link
                  to={"/"}
                  className="nav-link"
                  style={{ textDecoration: "none" }}
                >
                  <span className="home">Back Home</span>
                </Link>
                <Link
                  to={"/register"}
                  className="nav-link"
                  style={{ textDecoration: "none" }}
                >
                  <span className="home">Don't have an account?</span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginForm;
